import { Greeting } from "@/components/today/Greeting";
import { WeatherWidget } from "@/components/today/WeatherWidget";
import { ThisWeeksTasksCard } from "@/components/today/ThisWeeksTasksCard";
import { GardenHealthCard } from "@/components/today/GardenHealthCard";
import { RecentJournalPlaceholder } from "@/components/today/RecentJournalPlaceholder";
import { PlanBuilderPlaceholder } from "@/components/today/PlanBuilderPlaceholder";

export function Today() {
  return (
    <section data-testid="today-page" className="space-y-4 pb-4">
      <Greeting />
      <WeatherWidget />
      <ThisWeeksTasksCard />
      <GardenHealthCard />
      <RecentJournalPlaceholder />
      <PlanBuilderPlaceholder />
    </section>
  );
}
